var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 4.20068H15.5797",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9379 4.20032V15.4002C13.938 15.6104 13.8956 15.8184 13.8131 16.0126C13.7307 16.2067 13.6097 16.3831 13.4572 16.5317C13.3047 16.6802 13.1237 16.7981 12.9244 16.8784C12.7252 16.9588 12.5116 17.0001 12.296 17H4.08383C3.86818 17.0001 3.65463 16.9588 3.45538 16.8784C3.25612 16.7981 3.07506 16.6802 2.92257 16.5317C2.77008 16.3831 2.64915 16.2067 2.56668 16.0126C2.4842 15.8184 2.44179 15.6104 2.44189 15.4002V4.20032M4.90521 4.20032V2.59976C4.9051 2.38965 4.94749 2.18157 5.02997 1.98744C5.11245 1.7933 5.2334 1.6169 5.38589 1.46833C5.53838 1.31975 5.71944 1.20192 5.91869 1.12156C6.11795 1.0412 6.3315 0.999896 6.54715 1H9.83185C10.0475 0.999896 10.261 1.0412 10.4603 1.12156C10.6596 1.20192 10.8406 1.31975 10.9931 1.46833C11.1456 1.6169 11.2665 1.7933 11.349 1.98744C11.4315 2.18157 11.4739 2.38965 11.4738 2.59976V4.20032",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54688 8.2002V13.0003",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83252 8.2002V13.0003",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteW);
export default __webpack_public_path__ + "static/media/deleteW.e11086531d5771c5e9031dd47d166054.svg";
export { ForwardRef as ReactComponent };